//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EspecialidadesAPI from "@/api/promotores/cursos/especialidades.api";
import EspecialidadForm from "./EspecialidadForm";

export default {
  data() {
    return {
      loading: true,
      especialidades: [],
    };
  },

  mounted() {
    this.loadEspecialidades();
  },

  methods: {
    async loadEspecialidades() {
      try {
        this.loading = true;
        this.especialidades = await EspecialidadesAPI.all();
      } finally {
        this.loading = false;
      }
    },

    crearEspecialidad() {
      this.$q
        .dialog({
          component: EspecialidadForm,
        })
        .onOk((especialidad) => {
          this.loadEspecialidades();
        });
    },

		editarEspecialidad(especialidad) {
			this.$q
        .dialog({
          component: EspecialidadForm,
					especialidad
        })
        .onOk((especialidad) => {
          this.loadEspecialidades();
        });
		}
  },
};
